/**
 * Maps a lower-cased file extension to the base name of its icon in `src/Icons/file-icon`, which
 * `FileExtensionIcon` suffixes with `Icon` to pick the component.
 *
 * Unsuffixed and shared by both platforms: the icon barrel it names is generated once from Figma for
 * web and native alike, so there is exactly one correct spelling per entry and no room for the two
 * sides to diverge. Keys must stay lower-case — lookups pass `extension.toLowerCase()`.
 *
 * `as const` is load-bearing. It keeps the values literal so each platform file can check them
 * against its own icon barrel, which is what turns a misspelt name into a compile error instead of a
 * silent fallback to the generic icon. The check cannot live here: this file is unsuffixed, and
 * per CLAUDE.md an unsuffixed module must not import a platform-resolved barrel even for a type.
 */
export const fileExtensionsReferences = {
  /* IMAGES */
  jpg: 'Jpg',
  jpeg: 'Jpg',
  heic: 'Jpg',
  png: 'Png',
  gif: 'Gif',
  tiff: 'Tiff',
  bmp: 'Bmp',
  /* DOCUMENTS */
  doc: 'Doc',
  docx: 'Doc',
  xls: 'Xls',
  xlsx: 'Xls',
  csv: 'Csv',
  xlsm: 'Xlsm',
  xlm: 'Xlm',
  ppt: 'Ppt',
  pptx: 'Ppt',
  txt: 'Txt',
  pdf: 'Pdf',
  msg: 'Msg',
  eml: 'Eml',
  /* VIDEO */
  mp4: 'Mp4',
  mov: 'Mov',
  avi: 'Avi',
  mpg: 'Mpg',
  flv: 'Flv',
  wmv: 'Wmv',
  /* SOUND */
  mp3: 'Mp3',
  wav: 'Wav',
  wma: 'Wma',
  /* CAD */
  dgn: 'Dgn',
  dwg: 'Dwg',
  dwt: 'Dwt',
  nwd: 'Nwd',
  '3dm': 'Threedm',
  cnv: 'Cnv',
  skp: 'Skp',
  '3mf': 'Threemf',
  rvm: 'Rvm',
  /* BIM */
  ifc: 'Ifc',
  db1: 'Db1',
  dxf: 'Dxf',
  rvt: 'Rvt',
  /* PROJECT MANAGEMENT */
  mpp: 'Mpp',
  xer: 'Xer',
  asta: 'Asta',
  /* OTHER */
  svg: 'Svg',
  zip: 'Zip',
  rar: 'Zip',
  gzip: 'Zip',
  psd: 'Psd',
} as const;
